<mat-card class="card">
  <mat-card-header ali>
    <mat-card-title>
      <h1>Contact</h1>
    </mat-card-title>
  </mat-card-header>
  <br><br>
  <mat-card-content>
    <h2>Manuel</h2>
    <a href="tel:+4915225964039" target="_blank" mat-button>+4915225964039</a>
  </mat-card-content>
</mat-card>
